function invalid(error) {
  return { valid: false, normalized: null, error };
}

export function validateNumber(value, digits) {
  if (!Number.isSafeInteger(digits) || digits <= 0) {
    return invalid('digits must be a positive safe integer');
  }

  let text;
  if (typeof value === 'number') {
    if (value < 0) return invalid('value must not be negative');
    if (!Number.isFinite(value) || !Number.isInteger(value)) {
      return invalid('value must be an integer without decimals');
    }
    if (!Number.isSafeInteger(value)) return invalid('value must be a safe integer');
    text = String(value);
  } else if (typeof value === 'string') {
    if (value.startsWith('-')) return invalid('value must not be negative');
    if (value.includes('.')) return invalid('value must be an integer without decimals');
    if (!/^\d+$/.test(value)) return invalid('value must contain digits only');
    text = value;
  } else {
    return invalid('value must be a string or number containing digits only');
  }

  if (text.length > digits) return invalid(`value must not exceed ${digits} digits`);
  return { valid: true, normalized: text.padStart(digits, '0'), error: null };
}

export function formatNumber(value, digits) {
  const result = validateNumber(value, digits);
  if (!result.valid) {
    const ErrorType = result.error.startsWith('digits') || /negative|exceed/.test(result.error)
      ? RangeError
      : TypeError;
    throw new ErrorType(result.error);
  }
  return result.normalized;
}
